const data = {
  state: {
    iconsMap: []
  },
  generate(iconsMap) {
    this.state.iconsMap = iconsMap
  }
}

export default data



// WEBPACK FOOTER //
// ./src/view/svg-icons/generateIconsView.js